
import { useEffect, useState } from 'react'


import ReactLoading from "react-loading"
import { useGlobal, useGlobalUpdate } from '../../../contexts/GlobalContext'
import { useProtected, useProtectedUpdate } from '../../../contexts/ProtectedContext'

import { useLocation, Link } from "react-router-dom"


import { auth_axios } from '../../../libs/authWeb';
import { mixpanel_client_track } from '../../../libs/mixpanelClient';







const HomePage = ({
  
} : {
  
}) => {


  // Global context
  const global_context = useGlobal()
  const global_update = useGlobalUpdate()

  // Protected context
  const protected_context = useProtected()
  const protected_update = useProtectedUpdate()

  // Location
  const location = useLocation()

  // User data
  const [account_data, set_account_data] = useState({})
  const [account_data_is_fetched, set_account_data_is_fetched] = useState(false)

  // Refresh variable
  const [refresh_variable, set_refresh_variable] = useState(Date.now())

  // Test call status
  const [test_call_data, set_test_call_data] = useState({})

  const trigger_test_call = async () => {
    // Execute get user data
    const get_test_res = await auth_axios.get(`/api/test/kalshi-fns`)

    if (!get_test_res.data.success) {
      switch (get_test_res.data.status) {
        case "FATAL_ERROR": {
          alert("Fatal error")
          
          // Always break
          break
        }
        default: {
          // Always break
          break
        }
      }
      return
    }

    // Set states
    set_test_call_data(get_test_res.data.test_call_data)
  }

  



  const get_account_data = async () => {

    return

    // await axios.put('/api/test/four')


    // Set is_fetched to false
    set_account_data_is_fetched(false)

    // Execute get user data
    const get_org_res = await auth_axios.get(`/api/accounts`)

    if (!get_org_res.data.success) {
      switch (get_org_res.data.status) {
        case "FATAL_ERROR": {
          alert("Fatal error")
          
          // Always break
          break
        }
        default: {
          // Always break
          break
        }
      }
      return
    }

    // Set states
    set_account_data(get_org_res.data.account_data)
    set_account_data_is_fetched(true)
  }


  

  // Renders 
  useEffect(() => {

    get_account_data()

    // // Mixpanel tracking
    // mixpanel_client_track("app_dashboard_test_visited", global_context.user_id)

  }, [refresh_variable])

  return (
    <div className="px-4 py-8 pb-32 md:py-16 sm:px-6 md:flex-auto md:px-0 md:py-8">
      <div className="mx-auto max-w-2xl space-y-16 sm:space-y-20 md:mx-0 md:max-w-none">
        <div>
          <h2 className="text-base font-semibold leading-7 text-gray-900">Testing Sandbox</h2>
          <p className="mt-1 text-sm leading-6 text-gray-500">
            Test data below
          </p>

          {/* Trigger button */}
          <dl className="mt-6 space-y-6 divide-y divide-gray-100 border-t border-gray-200 text-sm leading-6">
            <div className="pt-6 sm:flex">
              <dd className="mt-1 flex flex-col gap-y-2 sm:mt-0 sm:flex-auto">
                <div>
                  <button
                    type="button"
                    className="flex w-full sm:w-auto justify-center rounded-md bg-blue-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 h-10 items-center disabled:opacity-60 disabled:cursor-not-allowed"
                    onClick={trigger_test_call}
                  >
                    {false
                    ? <ReactLoading type='spokes' color='#ffffff' height={18} width={18} />
                    : <span>Trigger backend call</span>}
                  </button>
                </div>
              </dd>
            </div>
          </dl>

          {/* Data */}

        </div>

      </div>




    </div>
  )
}

export default HomePage